import type { MarginMode } from "../constants/order-form.constants.ts";

export type CoinMarginMode = "strictIsolated" | "noCross";

export type MarginCapability = {
	supportsCrossMargin: boolean;
	defaultMarginMode: MarginMode;
	crossDisabledReasonKey?: "margin.isolated-only";
};

type GetMarginCapabilityParams = {
	coinMarginMode?: CoinMarginMode | null;
};

export function getMarginCapability({
	coinMarginMode,
}: GetMarginCapabilityParams): MarginCapability {
	const normalizedCoinMarginMode = coinMarginMode ?? undefined;
	const supportsCrossMargin =
		normalizedCoinMarginMode !== "strictIsolated" &&
		normalizedCoinMarginMode !== "noCross";

	return {
		supportsCrossMargin,
		defaultMarginMode: supportsCrossMargin ? "Cross" : "Isolated",
		crossDisabledReasonKey: supportsCrossMargin
			? undefined
			: "margin.isolated-only",
	};
}
